<template>
    <div class="usericon">

        <font-awesome-layers full-width class="fa-2x">
            <font-awesome-icon icon="square"></font-awesome-icon>
            <font-awesome-layers-text :value="name.substr(0,1).toUpperCase()" class="userletter"
                    transform="shrink-2"></font-awesome-layers-text>
            <img class="userimage" v-show="imageLoaded"
                    :src="`https://seccdn.libravatar.org/avatar/${hash}?s=24&d=404`"
                    height="24" width="24" @load="onImageLoaded">
        </font-awesome-layers>
    </div>
</template>

<script>
import { FontAwesomeLayers, FontAwesomeIcon, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import md5 from 'js-md5';

export default {
  name: 'userIcon',
  components: { FontAwesomeLayersText, FontAwesomeIcon, FontAwesomeLayers },
  data: function() {
    return {
      imageLoaded: false
    };
  },
  props: {
    name: String,
    size: {
      type: String,
      default: 'md'
    }
  },
  methods: {
    onImageLoaded() {
      this.imageLoaded = true;
    }
  },
  computed: {
    hash() {
      return md5(this.$store.state.senderAddress);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    img.userimage {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: auto;
        height: auto;
    }

    .userletter {
        color: $light;
        font-weight: bold;
    }
    .usericon2 {
        background-color: $gray-800;
        color: $light;
        width: 1.25em;
        text-align: center;
        border-radius: 5px;
        padding: 0px;
        padding-top: -5px;
        height: 1em;
        vertical-align: -0.125em;
        overflow: visible;
        &.size-2x {
            font-size: 2em;
        }
    }
</style>
